import request from '../request';
// 获取用户是否有群发模版
// /pdMassMessage/getUserIsMassSetting/{idUser}
// idUser 用户id
// 返回值
// {
//     "code": 200,
//     "msg": "操作成功",
//     "data": {
//         "mail": true,//是否有邮件模版
//         "mailJobId": "17",//邮件模版id
//         "message": true,//是否有消息模版
//         "messageJobId": "18"//消息模版id
//     }
// }
export const getUserIsMassSetting = (params) => {
  return request({
    url: `/pdMassMessage/getUserIsMassSetting/${params}`,
    method: 'post',
    platform: 'masSending',
    headers: {
      isEncrypt: false,
    },
  });
};
// 更新群发任务
// /pdMassMessage/updateMassTask
// 参数
// {
//   "idUser": "123",//用户id
//   "snailJobId": "17",//邮件模版id
//   "sendUserNum": 50,//发送人数
//   "intervalTime": 1123000//间隔时间
// }
export const updateMassTask = (data) => {
  return request({
    url: `/pdMassMessage/updateMassTask`,
    method: 'post',
    data,
    platform: 'masSending',
    headers: {
      isEncrypt: false,
    },
  });
};
// 创建定时任务模版
// /pdMassMessage/addTaskTemplate
// 参数
// {
//     "idUser": 123,//用户id
//     "messageContent": "发送聊天消息模版1",
//     "imagesUrl": "1,2,3,4",//图片路径
//     "imagesId": "1,2,3,4",//图片id
//     "videoUrl": "",//视频路径
//     "videoId": "",//视频id
//     "jobId": 13,//模版id
//     "jobType":0//0:邮件 1:消息
//   }
export const addTaskTemplate = (data) => {
  return request({
    url: `/pdMassMessage/addTaskTemplate`,
    method: 'post',
    data,
    platform: 'masSending',
    headers: {
      isEncrypt: false,
    },
  });
};

// pdMassMessage/batchAddTaskTemplate
// [
//   {
//     "idUser": "123",
//     "jobType": "1",
//     "messageContentList": [
//       "123",
//       "456"
//     ]
//   },
//    {
//     "idUser": "456",
//     "jobType": "1",
//     "messageContentList": [
//       "123",
//       "456"
//     ]
//   }
// ]
export const batchAddTaskTemplate = (data) => {
  return request({
    url: `/pdMassMessage/batchAddTaskTemplate`,
    method: 'post',
    data,
    platform: 'masSending',
    headers: {
      isEncrypt: false,
    },
  });
};

// 创建定时任务
// /pdMassMessage/addMassTask
// 参数
// {
//     "idUser": "123",//用户id
//     "jobType": "0",//0:邮件 1:消息
//     "unSendUserTime": "1",//多少小时未聊天的用户，单位小时
//     "sendUserNum": 10,//发送人数
//     "intervalTime": 480,//间隔时间，单位分钟
//     "pdUserAccount": "69593048@chnldx.com",//邮箱账户
//     "relevancyToken": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoidXNlciIsImlzcyI6ImRlZiIsInZlciI6IjEuMSIsImlhdCI6MTc1NjAwNTk5MywiZXhwIjoxNzU4Njg0MzkzLCJzdWIiOjY5NTkzMDQ4fQ.hN4fv0k3F_E1vjJPs_sl6kbkAiA3W6oO7JGGehVw4mM" //pdtoken
//   }
export const addMassTask = (data) => {
  return request({
    url: `/pdMassMessage/addMassTask`,
    method: 'post',
    data,
    platform: 'masSending',
    headers: {
      isEncrypt: false,
    },
  });
};

// 修改定时任务模版
// /pdMassMessage/editTaskTemplate
// {
//   "id": "1960613642035957761",
//   "imagesUrl": "1,2"
// }
export const editTaskTemplate = (data) => {
  return request({
    url: `/pdMassMessage/editTaskTemplate`,
    method: 'post',
    data,
    platform: 'masSending',
    headers: {
      isEncrypt: false,
    },
  });
};

// 批量创建定时任务(旧)
// /pdMassMessage/batchAddMassTask
// {
//   "idUserList": "456,123",batchAddMassTask
//   "jobType": "0",
//   "sendUserNum": 10,
//   "intervalTime": 480,
//   "unSendUserTime": 4
// }
export const batchAddMassTask = (data) => {
  return request({
    url: `/pdMassMessage/batchAddMassTask`,
    method: 'post',
    data,
    platform: 'masSending',
    headers: {
      isEncrypt: false,
    },
  });
};
// 批量创建定时任务(新)
// /pdMassMessage/batchAddMassTask
// {
//   "idUsers": [456,123],
//   "jobType": "0",//0:邮件 1:消息 ,2:邮件+消息
//   "sendUserNum": 10,
//   "intervalTime": 480,
//   "unSendUserTime": 4
// }
export const pdMassMessageMassTask = (data) => {
  return request({
    url: `/pdMassMessage/massTask`,
    method: 'post',
    data,
    platform: 'masSending',
    headers: {
      isEncrypt: false,
    },
  });
};
// 定时任务开启或关闭
// /pdMassMessage/update/status/{id}/{status}
// id 任务id
// status 1:开启 2:关闭
export const addOrDeleteJob = (id, status) => {
  return request({
    url: `/pdMassMessage/update/status/${id}/${status}`,
    method: 'post',
    platform: 'masSending',
    headers: {
      isEncrypt: false,
    },
  });
};
// 获取定时任务模板
// /pdMassMessage/getTaskTemplate/{idUser}/{jobType}
// idUser 用户id
// jobType 1:邮件 2:消息
// 参数
// {
// "pageSize": 10,
// "pageNum": 1
// }
export const getTaskTemplate = (idUser, jobType, data) => {
  return request({
    url: `/pdMassMessage/getTaskTemplate/${idUser}/${jobType}`,
    method: 'post',
    data,
    platform: 'masSending',
    headers: {
      isEncrypt: false,
    },
  });
};
// 批量删除定时任务模版
// /pdMassMessage/removeTaskTemplate/{jobId}/{id}
// jobId 模版id
// id 模版id 逗号拼接
export const removeTaskTemplate = (idUser, jobId, id) => {
  return request({
    url: `/pdMassMessage/removeTaskTemplate/${idUser}/${jobId}/${id}`,
    method: 'post',
    platform: 'masSending',
  });
};

// 获取白名单用户
// /pdUserBlacklist/list/{idUser}
export const getWhiteList = (idUser) => {
  return request({
    url: `/pdUserBlacklist/list/${idUser}`,
    method: 'post',
    platform: 'masSending',
    headers: {
      isEncrypt: false,
    },
  });
};

// 添加白名单用户
// /pdUserBlacklist/list
// 参数
// {
//     "idUser": "123", // 当前用户id
//     "blackUserName": "123", // 白名单用户名
//     "blackUserId": "123", // 白名单用户id
//     "blackUserAvatarUrl": "123" // 白名单用户头像
//   }
export const addWhiteList = (data) => {
  return request({
    url: `/pdUserBlacklist/add`,
    method: 'post',
    data,
    platform: 'masSending',
    headers: {
      isEncrypt: false,
    },
  });
};

// 删除白名单用户
// /pdUserBlacklist/delete/{id}
// id是逗号拼接的
export const deleteWhiteList = (platformUserId,idUser) => {
  console.log('删除白名单用户:', platformUserId,idUser);
  return request({
    url: `/pdUserBlacklist/delete/${platformUserId}/${idUser}`,
    method: 'post',
    platform: 'masSending',
    headers: {
      isEncrypt: false,
    },
  });
};
